import { create } from 'zustand';

import { createSelectors } from '../utils/zustand/createSelectors';

export type ToastTheme = 'dark-brown' | 'community-form' | 'dark-info';

interface ToastThemeState {
  /**
   * 토스트 테마 (아직 한 번도 띄우지 않았으면 null)
   * 1. 짙은 갈색 바탕에 흰 글씨, 화면 위 (dark-brown)
   * 2. 커뮤니티 레시피, 집밥일기 작성 관련 (community-form)
   * 3. 검은 바탕에 흰 글씨, 화면 아래 가로 꽉 참 (dark-info)
   */
  toastTheme: ToastTheme | null;

  /** 토스트 컨테이너 z-index override (null이면 기본값 사용) */
  toastZIndex: number | null;

  /** 토스트 테마 설정 */
  setToastTheme: (toastTheme: ToastTheme) => void;

  /** 토스트 컨테이너 z-index override 설정 */
  setToastZIndex: (toastZIndex: number | null) => void;
}

/**
 * 토스트 테마를 관리하는 Zustand store
 */
const useToastThemeStoreBase = create<ToastThemeState>((set) => ({
  toastTheme: null,
  toastZIndex: null,
  setToastTheme: (toastTheme: ToastTheme) => {
    set({ toastTheme });
  },
  setToastZIndex: (toastZIndex: number | null) => {
    set({ toastZIndex });
  },
}));

export const useToastThemeStore = createSelectors(useToastThemeStoreBase);
